import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const WiserrosWidgetSimple = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');
  const { user } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    console.log('WiserrosWidgetSimple mounted, isMobile:', isMobile, 'isAdminPage:', isAdminPage, 'path:', location.pathname);
  }, [isMobile, isAdminPage, location.pathname]);

  // Detect mobile screen size (768px breakpoint)
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Load widget only on desktop
  useEffect(() => {
    console.log('WiserrosWidgetSimple useEffect, isAdminPage:', isAdminPage, 'isMobile:', isMobile, 'user:', user);
    if (isAdminPage) {
      // Remove any existing widget container on admin pages
      const container = document.getElementById('wiserr-chat-widget-container');
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
      return;
    }
    if (isMobile) {
      // Remove any existing widget container on mobile
      const container = document.getElementById('wiserr-chat-widget-container');
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
      return;
    }

    // Check if script already exists
    const existingScript = document.querySelector('script[src="https://app.wiserros.com/widget.js"]');
    if (existingScript) {
      return;
    }

    console.log('Loading Wiserros widget for desktop...');
    const script = document.createElement('script');
    script.src = 'https://app.wiserros.com/widget.js';
    script.dataset.tenant = 'grupo-no-0xgs';
    if (user) {
      script.dataset.userId = user.uid;
      script.dataset.userEmail = user.email || '';
      script.dataset.userName = user.displayName || '';
    }
    script.async = true;
    
    script.onload = () => {
      console.log('Wiserros widget script loaded successfully');
      
      // Wait for widget container to appear
      const checkInterval = setInterval(() => {
        const container = document.getElementById('wiserr-chat-widget-container');
        if (container) {
          console.log('Wiserros widget container found');
          clearInterval(checkInterval);
          
          // Apply base styling
          container.style.position = 'fixed';
          container.style.zIndex = '999999';
          container.style.bottom = '20px';
          container.style.right = '20px';
          container.style.display = 'block';
          container.style.visibility = 'visible';
          container.style.opacity = '1';
          
          // Ensure no parent is hiding the widget
          let parent = container.parentElement;
          while (parent && parent !== document.body) {
            if (parent.style.display === 'none' || parent.style.visibility === 'hidden' || parent.style.opacity === '0') {
              parent.style.display = '';
              parent.style.visibility = '';
              parent.style.opacity = '';
            }
            parent = parent.parentElement;
          }
          
          // Set up a mutation observer to ensure styles persist
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                // If widget script modifies styles, reapply our styles after a short delay
                setTimeout(() => {
                  container.style.position = 'fixed';
                  container.style.zIndex = '999999';
                  container.style.bottom = '20px';
                  container.style.right = '20px';
                  container.style.display = 'block';
                  container.style.visibility = 'visible';
                  container.style.opacity = '1';
                }, 50);
              }
            });
          });
          
          observer.observe(container, { attributes: true, attributeFilter: ['style'] });
        }
      }, 100);
      
      setTimeout(() => clearInterval(checkInterval), 10000); // Increase timeout to 10 seconds
    };
    
    script.onerror = (e) => {
      console.error('Failed to load Wiserros widget script', e);
    };
    
    document.body.appendChild(script);

    return () => {
      // Don't remove script on cleanup to avoid reloading on route changes
    };
  }, [isMobile, isAdminPage, user]);

  return null;
};

export default WiserrosWidgetSimple;